/**
 * Storefront "Make an Offer" entry point.
 *
 * Deliberately thin. This file does NOT handle cards. It collects an amount,
 * posts it to the backend, and hands off to the Stripe Checkout URL the
 * backend returns. All validation is re-done server-side; the checks here are
 * only to avoid obviously-wasted round trips.
 *
 * Backend contract:
 *   POST /apps/einstein/offers
 *   body: { product_id, variant_id, amount_cents }
 *   ->   { checkout_url }
 */
(function () {
  var ENDPOINT = '/apps/einstein/storefront-offers';

  var modal = document.querySelector('[data-offer-modal]');
  var openBtn = document.querySelector('[data-offer-open]');
  if (!modal || !openBtn) return;

  var amountEl = modal.querySelector('[data-offer-amount]');
  var linkEl = modal.querySelector('[data-offer-link]');
  var counterEl = modal.querySelector('[data-offer-counter]');
  var messageEl = modal.querySelector('[data-offer-message]');
  var submitBtn = modal.querySelector('[data-offer-submit]');
  var errorEl = modal.querySelector('[data-offer-error]');

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    if (amountEl) amountEl.focus();
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
    clearError();
  }

  openBtn.addEventListener('click', openModal);

  // Arriving from a grid card's "Offer" link (?offer=1) - open straight away
  // so the two-step feels like one action.
  if (new URLSearchParams(window.location.search).get('offer') === '1') {
    openModal();
  }

  modal.querySelectorAll('[data-offer-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  if (!submitBtn) return;

  submitBtn.addEventListener('click', function () {
    clearError();

    var dollars = parseFloat(amountEl ? amountEl.value : '');
    if (!isFinite(dollars) || dollars <= 0) {
      showError('Enter an offer amount.');
      return;
    }

    // Backend is the authority on price rules; this is a courtesy check only.
    var listed = parseInt(openBtn.getAttribute('data-listed-price'), 10);
    var cents = Math.round(dollars * 100);
    if (isFinite(listed) && cents >= listed) {
      showError('Your offer is at or above the listed price - just add it to your cart instead.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Setting up\u2026';

    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: openBtn.getAttribute('data-product-id'),
        variant_id: openBtn.getAttribute('data-variant-id'),
        amount_cents: cents,
        price_match_link: linkEl ? linkEl.value.trim() : '',
        open_to_counter: counterEl ? counterEl.checked : true,
        message: messageEl ? messageEl.value.trim() : '',
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.error || 'Could not create the offer.');
          return data;
        });
      })
      .then(function (data) {
        if (!data.checkout_url) throw new Error('No checkout URL returned.');
        // Hand off to Stripe. Card capture happens entirely on their side.
        window.location.href = data.checkout_url;
      })
      .catch(function (err) {
        console.error('[offers] submit failed', err);
        showError(err.message || 'Something went wrong. Please try again.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Continue to card authorization';
      });
  });
})();
